import React from "react";
import PropTypes from "prop-types";

import DefaultTab from "./defaultTab";
import ClassicTab from "./classicTab";
import WidgetTab from "./widgetTab";

import "./tab.scss";

const Tab = props => {
  const { variant } = props;

  switch (variant) {
    case "widget":
      return <WidgetTab {...props} />;
    case "classic":
      return <ClassicTab {...props} />;
    default:
      return <DefaultTab {...props} />;
  }
};

Tab.propTypes = {
  variant: PropTypes.oneOf(["classic", "default", "widget"])
};

Tab.defaultProps = {
  variant: "default"
};

Tab.displayName = "OrionTab";

export default Tab;
